import { Check } from "lucide-react";
import {
  PLAYER_COLORS,
  PLAYER_BORDER_COLORS,
  PLAYER_COLOR_NAMES,
  PLAYER_COLOR_ORDER,
  PLAYER_ON_COLOR,
} from "@/lib/api";

// Same swatches as the setup screen, with the game's display names. Values are server colour ids.
export function ColorPicker({ value, taken = [], onChange }) {
  return (
    <div className="flex gap-3" data-testid="online-color-picker">
      {PLAYER_COLOR_ORDER.map((c) => {
        const selected = value === c;
        const disabled = taken.includes(c) && !selected;
        return (
          <button
            key={c}
            type="button"
            disabled={disabled}
            onClick={() => onChange(c)}
            aria-pressed={selected}
            aria-label={`colour ${PLAYER_COLOR_NAMES[c]}`}
            data-testid={`online-color-${c}${selected ? "-selected" : ""}`}
            className="flex flex-col items-center gap-1 disabled:opacity-30"
            style={{ cursor: disabled ? "not-allowed" : "pointer" }}
          >
            <span
              className="relative h-11 w-11 rounded-md flex items-center justify-center"
              style={{
                background: PLAYER_COLORS[c],
                border: `1px solid ${PLAYER_BORDER_COLORS[c]}`,
                boxShadow: selected ? "0 0 0 2px var(--card), 0 0 0 3.5px var(--sea)" : "none",
                color: PLAYER_ON_COLOR[c],
                transition: "box-shadow 150ms ease",
              }}
            >
              {selected && <Check size={18} strokeWidth={2.2} />}
            </span>
            <span style={{ fontSize: 12, fontWeight: selected ? 600 : 500, color: selected ? "var(--ink)" : "var(--ink-3)" }}>
              {PLAYER_COLOR_NAMES[c]}
            </span>
          </button>
        );
      })}
    </div>
  );
}

export function ColorChip({ color, label }) {
  return (
    <span className="inline-flex items-center gap-2" style={{ fontSize: 12, color: "var(--ink-3)" }}>
      <span
        className="inline-block h-5 w-5 rounded-[5px]"
        style={{ background: PLAYER_COLORS[color], border: `1px solid ${PLAYER_BORDER_COLORS[color]}` }}
      />
      {label ?? PLAYER_COLOR_NAMES[color]}
    </span>
  );
}
